import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AuthService } from '../../../../../auth/auth.service';
import { GameControlsBase } from '../../game-controls.base';
import { ManagerService } from '../../../../../core/services/manager.service';

@Component({
  selector: 'app-game-controls-mobile-vertical',
  templateUrl: './game-controls-mobile-vertical.component.html',
  styleUrls: ['./game-controls-mobile-vertical.component.scss']
})
export class GameControlsMobileVerticalComponent extends GameControlsBase implements OnInit, OnChanges {

  @Input() showChatBox: boolean;
  @Output() gameControlsAdditionalDataOnClickOutside = new EventEmitter<void>();

  constructor(
    public authService: AuthService,
    public managerService: ManagerService
    ) {
    super();
  }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges) {

    try {
      if (!changes.betControls.currentValue.showSlider) { this.showBetAction = false }
    } catch (error) {
      this.showBetAction = false
    }
  }

  gameControlsAdditionalDataClickOutside() {
    this.gameControlsAdditionalDataOnClickOutside.emit()
  }
}
